import React from 'react';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

let TableRow = React.createClass({

    overLimite: function () {
        this.props.aparicionLapizEdicion(this.props.row.Id);
    },

    render: function () {

        let valor = GlobalHelper.ConvertirNumeroMilesMillones(this.props.row.Valor);
        let limiteCompra = this.props.data.limiteCompra;
        let valorLimiteCompra;

        if (this.props.novedad) {
            let valorNovedad = this.props.novedad.ValorNovedad;
            let valorAnterior = this.props.novedad.ValorAnterior;

            if (this.props.novedadEditado) {
                if (this.props.novedadEditado.edited) {
                    valor = this.props.novedadEditado.ValorNovedad;
                }
                else {
                    valor = valorNovedad;
                }
            } else {
                valor = valorNovedad;
            }

            valorLimiteCompra = limiteCompra.find(x => x.Id == valor).Valor;
            valor = GlobalHelper.ConvertirNumeroMilesMillones(valorLimiteCompra);
        }
        
        return (
            <div className="row row-bold">
                <div className="col-md-2">
                </div>
                <div className="col-md-4">
                    <label className="label-primary">{this.props.row.Descripcion}</label>
                </div>
                <div className="col-md-6" onMouseOver={this.overLimite}>
                    <label className="label-secondary">$</label>
                    <label className="label-secondary color-azul-claro">{valor}</label>
                </div>
            </div>
        );
    }
});

export default TableRow